<template>
  <ValidationProvider
    :name="label"
    :rules="rules"
    v-slot="{ errors }"
    v-bind="$attrs"
    :vid="vid || getUUID()"
  >
    <!-- select로 표시 -->
    <template v-if="comboType == 'select'">
      <v-select
        :menu-props="{
          bottom: true,
          offsetY: true,
          ...menuProps,
        }"
        v-model="innerValue"
        v-bind="$attrs"
        v-on="$listeners"
        :label="label"
        :items="localeItems"
        item-text="codeName"
        item-value="codeVal"
        :error-messages="errors"
        :clearable="clearable"
        :select-all="selectAll"
        :outlined="outlined"
        :hide-details="hideDetails"
        :background-color="backgroundColor"
      >
        <!-- :return-object="returnObject" -->
        <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
          <slot :name="slot" v-bind="scope" />
        </template>
        <template v-if="selectAll" #prepend-item>
          <v-list-item ripple @click="toggleItem">
            <v-list-item-action>
              <v-icon :color="innerValue.length > 0 ? 'indigo darken-4' : ''">{{
                icon
              }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{
                $t("common.lbl.select_all")
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider class="mt-2"></v-divider>
        </template>
        <template #label>
          <slot name="label">
            {{ label }}
            <v-icon
              v-if="showRequiredMark && rules && rules.required"
              color="deep-orange darken-2"
              small
              class="mb-1"
            >
              mdi-asterisk
            </v-icon>
          </slot>
        </template>
      </v-select>
    </template>
    <!-- radio로 표시 -->
    <template v-else-if="comboType == 'radio'">
      <v-radio-group
        class="rx-radio-group"
        v-model="innerValue"
        :row="row"
        :mandatory="$attrs.mandatory"
        :disabled="$attrs.disabled"
        :readonly="$attrs.readonly"
        :error-messages="errors"
        :hide-details="hideDetails"
        :label="hiddenLabel ? null : label"
      >
        <div v-for="item in excludedItems" :key="item.codeVal">
          <v-radio
            :label="
              $rxt(`common.codes.${codes}.${item.codeVal}`, item.codeName)
            "
            :value="item.codeVal"
            :error-messages="errors"
          >
            <template #label v-if="rxStyle">
              <v-icon
                v-show="rxStyle[item.codeVal].icon"
                :color="
                  rxStyle[item.codeVal].color
                    ? rxStyle[item.codeVal].color
                    : null
                "
                left
              >
                {{ rxStyle[item.codeVal].icon }}
              </v-icon>
              {{ $t(`common.codes.${codes}.${item.codeVal}`, item.codeName) }}
            </template>
          </v-radio>
          <slot :name="`append-outer:${item.codeVal}`"></slot>
        </div>
      </v-radio-group>
    </template>
    <!-- button group으로 표시 -->
    <template v-else-if="comboType == 'button-group'">
      <v-btn-toggle
        color="rx-foreground pri-3"
        v-model="innerValue"
        v-bind="$attrs"
        v-on="$listeners"
      >
        <!-- TODO: 회수로는 필요가 없는가? AB테스트에서는 필요함. -->
        <v-btn
          v-for="item in excludedItems"
          :key="item.codeVal"
          :error-messages="errors"
          :value="item.codeVal"
          v-bind="$attrs"
          active-class="toggle-active-color"
        >
          <v-icon v-if="styleCode && rxStyle[item.codeVal]" left>
            {{ rxStyle[item.codeVal].icon }}
          </v-icon>
          <!-- v-bind="$attrs"
          v-on="$listeners" -->
          {{ $t(`common.codes.${codes}.${item.codeVal}`, item.codeName) }}
        </v-btn>
      </v-btn-toggle>
      <div
        class="error_message_wrapper"
        v-if="hideDetails == 'auto' ? errors.length != 0 : !hideDetails"
      >
        <v-expand-transition class="error_message">
          <div class="error--text" v-show="errors.length != 0">
            {{ errors[0] }}
          </div>
        </v-expand-transition>
      </div>
    </template>
    <!-- checkbox로 표시 -->
    <template v-else-if="comboType == 'checkbox'">
      <div v-if="row" class="d-flex rx-g-16">
        <v-checkbox
          class="rx-checkbox"
          v-for="item in excludedItems"
          v-model="innerValue"
          :label="$t(`common.codes.${codes}.${item.codeVal}`, item.codeName)"
          :value="item.codeVal"
          :key="item.codeVal"
          v-bind="$attrs"
          v-on="$listeners"
          :rules="rxCheckBoxErrors"
        ></v-checkbox>
      </div>
      <template v-else>
        <v-checkbox
          class="rx-checkbox rx-margin-bottom"
          :class="index == excludedItems.length - 1 ? 'rx-last' : ''"
          v-for="(item, index) in excludedItems"
          v-model="innerValue"
          :label="$t(`common.codes.${codes}.${item.codeVal}`, item.codeName)"
          :value="item.codeVal"
          :key="item.codeVal"
          v-bind="$attrs"
          v-on="$listeners"
          :rules="rxCheckBoxErrors"
        ></v-checkbox>
      </template>
      <div
        class="error_message_wrapper"
        v-if="
          hideDetails == 'auto' ? rxCheckBoxErrors.length != 0 : !hideDetails
        "
      >
        <v-expand-transition class="error_message">
          <div class="error--text" v-show="rxCheckBoxErrors.length != 0">
            {{ rxCheckBoxErrors[0] }}
          </div>
        </v-expand-transition>
      </div>
    </template>
    <!-- switch로 표시 -->
    <template v-else-if="comboType == 'switch'">
      <v-row v-if="row">
        <v-switch
          class="mx-2"
          v-for="item in excludedItems"
          v-model="innerValue"
          :label="$t(`common.codes.${codes}.${item.codeVal}`, item.codeName)"
          :value="item.codeVal"
          :key="item.codeVal"
          :inset="inset"
        ></v-switch>
      </v-row>
      <template v-else>
        <v-switch
          v-for="item in excludedItems"
          v-model="innerValue"
          :label="$t(`common.codes.${codes}.${item.codeVal}`, item.codeName)"
          :value="item.codeVal"
          :key="item.codeVal"
          :inset="inset"
        ></v-switch>
      </template>
    </template>
    <!-- Button으로 표시 -->
    <template v-else-if="comboType == 'button' || comboType == 'chip'">
      <v-menu
        offset-y
        nudge-bottom="5"
        transition="slide-y-transition"
        :open-on-click="openOnClick"
      >
        <template v-slot:activator="{ on }">
          <v-btn v-if="comboType == 'button'" v-bind="$attrs" v-on="on">
            <slot
              name="button-default"
              v-bind="{ selectedLabel: selectedLabel, label: label }"
            >
              <span v-text="selectedLabel ? selectedLabel : label"></span>
            </slot>
          </v-btn>
          <v-chip
            v-if="comboType == 'chip'"
            v-bind="$attrs"
            :label="tile"
            v-on="on"
          >
            <slot
              name="chip-default"
              v-bind="{ selectedLabel: selectedLabel, label: label }"
            >
              <span v-text="selectedLabel ? selectedLabel : label"></span>
            </slot>
          </v-chip>
        </template>
        <v-spacer></v-spacer>
        <v-list>
          <v-list-item
            v-for="item in items"
            :key="item.codeVal"
            @click.native="selectMenu(item)"
            dense
            :style="{ cursor: 'pointer' }"
          >
            <v-list-item-title>
              {{ $t(`common.codes.${codes}.${item.codeVal}`, item.codeName) }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
    <!-- card로 표시 -->
    <template v-else-if="comboType == 'card'">
      <v-item-group v-model="innerValue">
        <v-container class="ma-0 pa-0">
          <v-card-text
            v-model="label"
            class="ma-0 pa-0 text-subtitle-2"
            v-if="!hiddenLabel"
          >
            {{ label }}
          </v-card-text>

          <!-- Card - cols 사이즈로 배치 | props cardCols 값이 존재할 때 화면에 따른 width로 적용됨 -->
          <v-row v-if="rxCardCols"  justify="center">
            <v-col
              v-for="item in excludedItems"
              :key="item.codeVal"
              :cols="rxCardCols.cols"
              :md="rxCardCols.md"
            >
              <v-item v-slot="{ active, toggle }" :value="item.codeVal">
                <v-card
                  :color="
                    active
                      ? styleCode && rxStyle[item.codeVal].color
                        ? rxStyle[item.codeVal].color
                        : 'primary lighen-1'
                      : 'grey'
                  "
                  class="d-flex align-center"
                  dark
                  width="100%"
                  :height="rxCardSize.height + 'px'"
                  @click="editable ? toggle() : toggleError()"
                >
                  <v-scroll-y-transition>
                    <div
                      v-if="active"
                      class="display-1 flex-grow-1 text-center text-truncate ma-1"
                    >
                      <v-avatar
                        v-if="
                          styleCode &&
                          (rxStyle[item.codeVal].imgFile ||
                            rxStyle[item.codeVal].icon)
                        "
                        :size="rxCardSize.iconSize"
                        :tile="tile"
                      >
                        <v-img
                          v-show="rxStyle[item.codeVal].imgFile"
                          :src="rxStyle[item.codeVal].imgFile"
                        ></v-img>
                        <v-icon
                          v-show="rxStyle[item.codeVal].icon"
                          :size="rxCardSize.iconSize"
                        >
                          {{ rxStyle[item.codeVal].icon }}
                        </v-icon>
                      </v-avatar>
                      <div
                        class="white--text"
                        :class="[
                          rxCardSize.textClass ? rxCardSize.textClass : '',
                        ]"
                      >
                        {{
                          $t(
                            `common.codes.${codes}.${item.codeVal}`,
                            item.codeName
                          )
                        }}
                      </div>
                    </div>
                    <div
                      v-else
                      class="display-1 flex-grow-1 text-center text-truncate ma-1"
                    >
                      <v-avatar
                        v-if="
                          rxStyle &&
                          (rxStyle[item.codeVal].imgFile ||
                            rxStyle[item.codeVal].icon)
                        "
                        :size="rxCardSize.iconSize"
                        :tile="tile"
                      >
                        <v-img
                          v-show="rxStyle[item.codeVal].imgFile"
                          :src="getImgFile(item.codeVal)"
                        ></v-img>
                        <v-icon
                          v-show="rxStyle[item.codeVal].icon"
                          :size="rxCardSize.iconSize"
                        >
                          {{ rxStyle[item.codeVal].icon }}
                        </v-icon>
                      </v-avatar>
                      <div
                        class="white--text"
                        :class="[
                          rxCardSize.textClass ? rxCardSize.textClass : '',
                        ]"
                      >
                        {{
                          $t(
                            `common.codes.${codes}.${item.codeVal}`,
                            item.codeName
                          )
                        }}
                      </div>
                    </div>
                  </v-scroll-y-transition>
                </v-card>
              </v-item>
            </v-col>
          </v-row>
          <!-- Card - 지정된 rxCardSize width 사이즈로 배치 -->
          <div class="d-flex flex-wrap rx-g-24 justify-center" v-else>
            <div
              v-for="item in excludedItems"
              :key="item.codeVal"
              :style="{
                width: rxCardSize.width + 'px',
                height: rxCardSize.height + 'px',
              }"
            >
              <v-item v-slot="{ active, toggle }" :value="item.codeVal">
                <v-card
                  :color="
                    active
                      ? styleCode && rxStyle[item.codeVal].color
                        ? rxStyle[item.codeVal].color
                        : 'primary lighen-1'
                      : 'grey'
                  "
                  class="d-flex align-center"
                  dark
                  width="100%"
                  height="100%"
                  @click="editable ? toggle() : toggleError()"
                >
                  <v-scroll-y-transition>
                    <div
                      v-if="active"
                      class="display-1 flex-grow-1 text-center text-truncate ma-1"
                    >
                      <v-avatar
                        v-if="
                          styleCode &&
                          (rxStyle[item.codeVal].imgFile ||
                            rxStyle[item.codeVal].icon)
                        "
                        :size="rxCardSize.iconSize"
                        :tile="tile"
                      >
                        <v-img
                          v-show="rxStyle[item.codeVal].imgFile"
                          :src="rxStyle[item.codeVal].imgFile"
                        ></v-img>
                        <v-icon
                          v-show="rxStyle[item.codeVal].icon"
                          :size="rxCardSize.iconSize"
                        >
                          {{ rxStyle[item.codeVal].icon }}
                        </v-icon>
                      </v-avatar>
                      <div
                        class="white--text"
                        :class="[
                          rxCardSize.textClass ? rxCardSize.textClass : '',
                        ]"
                      >
                        {{
                          $t(
                            `common.codes.${codes}.${item.codeVal}`,
                            item.codeName
                          )
                        }}
                      </div>
                    </div>
                    <div
                      v-else
                      class="display-1 flex-grow-1 text-center text-truncate ma-1"
                    >
                      <v-avatar
                        v-if="
                          rxStyle &&
                          (rxStyle[item.codeVal].imgFile ||
                            rxStyle[item.codeVal].icon)
                        "
                        :size="rxCardSize.iconSize"
                        :tile="tile"
                      >
                        <v-img
                          v-show="rxStyle[item.codeVal].imgFile"
                          :src="getImgFile(item.codeVal)"
                        ></v-img>
                        <v-icon
                          v-show="rxStyle[item.codeVal].icon"
                          :size="rxCardSize.iconSize"
                        >
                          {{ rxStyle[item.codeVal].icon }}
                        </v-icon>
                      </v-avatar>
                      <div
                        class="white--text"
                        :class="[
                          rxCardSize.textClass ? rxCardSize.textClass : '',
                        ]"
                      >
                        {{
                          $t(
                            `common.codes.${codes}.${item.codeVal}`,
                            item.codeName
                          )
                        }}
                      </div>
                    </div>
                  </v-scroll-y-transition>
                </v-card>
              </v-item>
            </div>
          </div>
          <div
            class="error_message_wrapper"
            v-if="hideDetails == 'auto' ? errors.length != 0 : !hideDetails"
          >
            <v-expand-transition class="error_message">
              <div class="error--text" v-show="errors.length != 0">
                {{ errors[0] }}
              </div>
            </v-expand-transition>
          </div>
        </v-container>
      </v-item-group>
    </template>
  </ValidationProvider>
</template>

<script>
import { $getCommCodes } from "@/redworks/api/commcode";
import { ValidationProvider } from "vee-validate";
export default {
  components: {
    ValidationProvider,
  },
  props: {
    value: {
      type: [String, Array, Object, Number, Boolean],
    },
    comboType: {
      // select, radio, checkbox, switch, button-group
      type: String,
      default: "select",
    },
    excludes: {
      type: Array,
      defaults: [],
    },
    label: {
      type: String,
      default: "",
    },
    hiddenLabel: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: [Object, String],
      default: "",
    },
    codes: String,
    clearable: {
      type: Boolean,
      default: true,
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Boolean,
      default: false,
    },
    selectAll: {
      type: Boolean,
      default: false,
    },
    extItems: Array,
    extItemText: String,
    extItemValue: String,
    editable: {
      type: Boolean,
      default: true,
    },
    tile: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      // card/checkbox/button-group 에서 error-message 영역 제한
      type: [Boolean, String],
      default: false,
    },
    inset: {
      type: Boolean,
      default: true,
    },
    openOnClick: {
      type: Boolean,
      default: true,
    },

    /** Default UI/UX 디자인 설정 */
    outlined: {
      // 적용대상: select
      type: Boolean,
      default: true,
    },
    cardSize: {
      // 적용대상: card
      type: String, // 'lg' 'md'(default) 'sm'
    },
    cardCols: {
      type: [Number, Object], // Number: cols 사이즈 | Object: {cols: #(필수), md: #(선택)}
    },
    styleCode: String, // RX_STYLE에 등록된 스타일 코드값(color/imgFile/icon) | 적용대상: card
    backgroundColor: {
      type: String,
      default: "white",
    },
    showRequiredMark: {
      // 필수아이콘(*) 표시여부
      type: Boolean,
      default: true,
    },

    /** vee-validate : ValidationProvider unique key 필요  */
    vid: {
      // v-for 일 때 label 동일하여 name 중복시 vid로 구별 필요
      type: [Number, String],
    },
  },
  computed: {
    excludedItems() {
      return this.items.filter((item) => {
        return (
          this.excludes == undefined || !this.excludes.includes(item.codeVal)
        );
      });
    },
    likesAllSelected() {
      return this.innerValue.length === this.excludedItems.length;
    },
    likesSomeSelected() {
      return this.innerValue.length > 0 && !this.likesAllSelected;
    },
    icon() {
      if (this.likesAllSelected) return "$vuetify.icons.fld_all_selected";
      if (this.likesSomeSelected) return "$vuetify.icons.fld_some_selected";
      return "$vuetify.icons.fld_none_selected";
    },
    selectedLabel() {
      let selectedLabel = "";
      this.items.forEach((item) => {
        if (item.codeVal == this.innerValue) {
          selectedLabel = this.$t(
            `common.codes.${this.codes}.${item.codeVal}`,
            item.codeName
          );
          // selectedLabel = item.codeName;
        }
      });
      return selectedLabel;
    },
    localeItems() {
      // 1. externerItem이 아닌 경우
      // this. codes
      // this.items
      let localeItem = this.items;
      this.items.forEach((i) => {
        i.codeName = this.$rxt(
          `common.codes.${this.codes}.${i.codeVal}`,
          i.codeName
        );
      });
      return localeItem.filter((item) => {
        return (
          this.excludes == undefined || !this.excludes.includes(item.codeVal)
        );
      });
    },
    rxCheckBoxErrors() {
      if (this.rules && this.rules.required) {
        // validation - required 일때, checkbox는 innerValue 값이 존재하면 false 존재하지 않으면 error-message 반환
        if (this.innerValue && this.innerValue.length > 0) {
          return [];
        } else {
          return [this.$t("common.valid.required", [this.label])];
        }
      } else {
        return [];
      }
    },
    rxCardSize() {
      if ("lg" == this.cardSize) {
        return {
          width: 180,
          height: 120,
          iconSize: 40,
          textClass: "rx-text-h4",
        };
      } else if ("sm" == this.cardSize) {
        return {
          width: 100,
          height: 70,
          iconSize: 24,
          textClass: "rx-text-h6",
        };
      } else if ("xsm" == this.cardSize) {
        return {
          width: 95,
          height: 95,
          iconSize: 24,
          textClass: "rx-text-h6",
        };
      } else {
        // default "md"
        return {
          width: 140,
          height: 98,
          iconSize: 32,
          textClass: "rx-text-h5",
        };
      }
    },
    rxCardCols() {
      if ("number" == typeof this.cardCols) {
        return { cols: this.cardCols, md: this.cardCols };
      } else if (
        "object" == typeof this.cardCols &&
        "number" == typeof this.cardCols.cols
      ) {
        let cardCols = { cols: this.cardCols.cols, md: this.cardCols.cols };
        if (this.cardCols.md) {
          cardCols.md = this.cardCols.md;
        }
        return cardCols;
      } else {
        return null;
      }
    },
    rxStyle() {
      if (this.styleCode && this.RX_STYLE[this.styleCode]) {
        return this.RX_STYLE[this.styleCode];
      } else {
        return null;
      }
    },
  },
  data() {
    return {
      innerValue: [],
      radioVal: null,
      items: [],
      loading: false,
      menuProps: {
        value: false,
        closeOnClick: true,
        openOnClick: true,
        closeOnContentClick: !this.$attrs.multiple,
      },
    };
  },
  methods: {
    async getCommCodes() {
      try {
        this.loading = true;
          
        const commCodes = this.$store.state.app.commCodes;
        // commCodes배열오브젝트에서 upCodeVal이 codes와 동일한 데이터 취득
        const items = commCodes.filter(
          (code) => code.upCodeVal === this.codes
        );
        if (items.length > 0) {
          this.items = items;
        } else {
          let params = {
            upCodeVal: this.codes,
            usable: true,
          };
          const { data } = await $getCommCodes(params);

          const rstCodes = data.result;
          this.items = rstCodes;
          this.$store.commit("app/SET_COMMCODES", rstCodes);
        }
      } catch (error) {
        this.$rxSnackbar("error", this.$t("common.msg.unexpected_error"));
      } finally {
        this.loading = false;
      }
    },
    async getExteralItems() {
      let codes = [];
      this.extItems.forEach((i) => {
        codes.push({
          codeVal: this.returnObject ? i : i[this.extItemValue],
          codeName: i[this.extItemText],
        });
      });
      this.items = codes;
    },
    toggleItem() {
      this.$nextTick(() => {
        if (this.likesAllSelected) {
          this.innerValue = [];
        } else {
          const slicedItems = this.excludedItems.slice().map((item) => {
            return item.codeVal;
          });
          this.innerValue = slicedItems;
        }
      });
    },
    selectMenu(item) {
      const changed = this.innerValue != item.codeVal;
      this.innerValue = item.codeVal;
      if (changed) {
        this.$emit("change", this.innerValue, this.$attrs.id);
      }
    },
    toggleError() {
      this.$emit("toggleError");
    },
    getImgFile(codeVal) {
      if (codeVal && this.RX_STYLE[this.styleCode][codeVal].img) {
        return this.RX_STYLE[this.styleCode][codeVal].imgFile;
      }
      return require("@/redworks/assets/logo.png"); // default로
    },
    openSelect(delay = 100) {
      setTimeout(() => (this.menuProps.value = true), delay);
    },
  },
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit("input", newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    },
    async extItems() {
      if (this.extItems) {
        await this.getExteralItems();
      }
    },
  },
  async created() {
    if (this.extItems) {
      await this.getExteralItems();
    } else {
      await this.getCommCodes();
    }
    if (this.value) {
      this.innerValue = this.value;
    }
  },
};
</script>

<style lang="scss" scoped>
.error_message_wrapper {
  flex: 1 1 auto;
  font-size: 12px;
  min-height: 24px;
  min-width: 1px;
  position: relative;
}
.error_message {
  line-height: 12px;
}
::v-deep .v-input--selection-controls {
  margin-top: 0px !important;
  padding-top: 0px !important;
}

.toggle-active-color {
  .v-icon {
    color: var(--fg-base-pri-3) !important;
  }
}

::v-deep .rx-radio-group {
  .v-input--radio-group__input {
    gap: 8px;
  }
}

::v-deep .rx-checkbox {
  .v-messages {
    display: none;
  }
}
::v-deep .rx-margin-bottom {
  .v-input__slot {
    margin-bottom: 16px;
  }
}
::v-deep .rx-last .v-input__slot {
  margin-bottom: 0px !important;
}
</style>
